export default __webpack_public_path__ + "static/media/Mark-3-HUD-07.28b902f5.jpg";